import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withStyles} from '@material-ui/core/styles/index'
import {withRouter} from "react-router-dom"
import {
    AppBar,
    Button,
    Card,
    CardContent,
    Input,
    Paper,
    Toolbar,
    Typography,
} from '@material-ui/core';
import {UecareUploadAvatar, UecareLightBox} from "../../../../../components";
import MissionService from '../../../../../service/mission'
import VipService from '../../../../../service/vip'
import {bindActionCreators} from "redux";
import ReduxMission from "../../../../../store/actionreducers/mission";
import cities from '../../../../../constants/city';

class PeopleTab extends Component {

    index = 0;

    state = {
        actionType: 'view', // view . add . edit
        tempImages: [],
        index: 0,
        changingUserId: null,
        validatedChangingVipId: null,
        validatedChangingUserName: '',
        changingPatientInProgress: false,
        validationInProgress: false,
    };

    resetValidatedChangingUserName() {
        this.setState({validatedChangingVipId: null})
        this.setState({validatedChangingUserName: ''})
    }

    async validateUserId(userId) {
        if (!userId) return this.resetValidatedChangingUserName()
        const { ok, vip } = await VipService.findByUserId(userId)
        if (!ok) return this.resetValidatedChangingUserName()
        this.setState({
            validatedChangingUserName: vip.user.name,
            validatedChangingVipId: vip.id,
        })
    }

    async onChangeInputUserId(inputUserId) {
        this.setState({validationInProgress: true})
        await this.validateUserId(inputUserId)
        this.setState({
            changingUserId: inputUserId,
            validationInProgress: false,
        })
    }

    async onClickChangePatient() {
        const { tempMission, getMission, setMission } = this.props
        const { validatedChangingVipId } = this.state
        const missionId = tempMission.id

        this.setState({changingPatientInProgress: true})
        // Change the patient
        await MissionService.changePatient({
            missionId,
            vipId: validatedChangingVipId,
        })

        // Reload the data
        const mission = await getMission(missionId)
        await setMission(mission)

        // reset input text
        this.resetValidatedChangingUserName()
        this.setState({changingUserId: ''})
        this.setState({changingPatientInProgress: false})
    }

    getIndex() {
        return this.index++;
    }

    getUserPhoneNumber(user) {
        if (!user) return '';
        if (user.phone_country_code && user.phone_number)
          return `(+${user.phone_country_code})${user.phone_number}`;
        if (user.phone_number) return user.phone_number;
        if (user.cell_phone_no) return user.cell_phone_no;
        const { owner } = user;
        if (owner) return this.getUserPhoneNumber(owner);
    };

    renderPaper(vip) {
        const vipCityId = vip && vip.visit_address && vip.visit_address.fk_city_id
        const livingArea = vipCityId && cities.find(c => c.id === vip.visit_address.fk_city_id).name
        const phoneNumber = this.getUserPhoneNumber(vip && vip.user)
        if (vip && vip.user && vip.user.avatar) {
            return (
                <Paper key={this.getIndex()}>
                    <div className="flex flex-1 flex-row">
                        <UecareUploadAvatar canChangeAvatar={false} src={vip.user.avatar.url}
                                            className="xl:w-128 xl:h-128 lg:w-128 lg:h-128 w-64 h-64 m-12"/>
                        <div className="flex flex-1 flex-col justify-center">
                            <div>姓名 : {vip.user.name}</div>
                            <div>電話 : {phoneNumber}</div>
                            {vip.user.fk_role_id === 5
                                &&
                                <div>
                                    <div>身分證字號 : {vip.user.id_no}</div>
                                    <div>出生年月日 : {vip.user.birthday}</div>
                                    <div>居住地 : {livingArea}</div>
                                    <div>地址 : {vip.visit_address && vip.visit_address.address}</div>
                                </div>
                            }
                        </div>
                    </div>
                </Paper>
            );

        } else return '';
    }

    renderPapers(vips = []) {
        return vips.map((vip) => {
            return this.renderPaper(vip);
        });
    }

    renderCard({title, vips, ownerPhone, titleColor = 'primary'}) {
        return (
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0} color={titleColor}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            {title}
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div>
                        {this.renderPapers(vips, ownerPhone)}
                    </div>
                </CardContent>
            </Card>
        );
    }

    render() {
        const { tempMission, classes } = this.props
        const { actionType, tempImages, vip, changingUserId, validationInProgress, validatedChangingVipId, validatedChangingUserName, changingPatientInProgress } = this.state        
        // 燈箱 ( light-box ) 參考資料 : https://github.com/jossmac/react-images
        if (actionType === 'view') {
            return (
                <div>
                    <UecareLightBox images={tempImages} ref={ref => this.uecareLightBox = ref}/>
                    <Input
                        placeholder="請輸入會員編號"
                        type="number"
                        value={changingUserId}
                        onChange={event => {
                            const inputUserId = event.target.value
                            this.onChangeInputUserId(inputUserId)
                        }}
                    />
                    <Button
                        variant="outlined"
                        className={classes.changePatientButton}
                        onClick={() => this.onClickChangePatient()}
                        disabled={!validatedChangingVipId || changingPatientInProgress}
                    >
                        { changingPatientInProgress
                            && '更換病人中...'
                        }
                        {!changingPatientInProgress
                            && `更換病人 ${(validatedChangingVipId) 
                            ? `(編號 ${changingUserId} ${validatedChangingUserName || ''})`
                            : ''}`}
                    </Button>
                    { !validationInProgress && changingUserId && !validatedChangingVipId
                        && <span className={classes.notFoundMessage}>
                            {`查無此會員: 編號 ${changingUserId}`}
                        </span>
                    }
                    {this.renderCard({title: '服務請求會員', vips: [tempMission.requester]})}
                    {this.renderCard({title: '目標服務會員', vips: [tempMission.target], titleColor: 'secondary'})}
                    {this.renderCard({title: '醫師', vips: [tempMission.provider], titleColor: 'secondary'})}
                    {this.renderCard({title: '陪同諮詢會員', vips: [vip, vip], titleColor: 'default'})}
                </div>
            )
        } else return '';
    }
}

// https://www.npmjs.com/package/react-event-timeline
const styles = theme => ({
    root: {},
    notFoundMessage: {
        marginLeft: 15,
        color: 'red',
    },
    changePatientButton: {
        marginBottom: 15,
    }
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMission: ReduxMission.ActionCreator.getMission,
        setMission: ReduxMission.ActionCreator.setMission,
    }, dispatch)
}

function mapStateToProps({mission: {temp}}) {
    return {
        tempMission: temp
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(PeopleTab)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/tabs/PeopleTab.js